export default __webpack_public_path__ + "static/media/poweredByStripe.5b4e931c.svg";